/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import ApproveSubscription from "./ApproveSubscription";
import DenySubscription from "./DenySubscription";
import { Box } from "@material-ui/core";
import { INotification } from "pages/home/notifications/components/NotificationList.controller";
export interface NotificationActionsProps {
  notification: INotification;
  refreshApprovals: () => void;
}
export const SubscriptionNotificationActions: React.FC<NotificationActionsProps> = ({
  notification,
  refreshApprovals
}) => {
  return (
    <>
      <Box display="flex">
        <ApproveSubscription notification={notification} refreshApprovals={refreshApprovals}/>
        <Box mx={1} />
        <DenySubscription notification={notification} refreshApprovals={refreshApprovals} />
      </Box>
    </>
  );
};

export default SubscriptionNotificationActions;
